import { render, staticRenderFns } from "./ProjectComments.vue?vue&type=template&id=85d5edcc&scoped=true&lang=html&"
import script from "./ProjectComments.vue?vue&type=script&lang=js&"
export * from "./ProjectComments.vue?vue&type=script&lang=js&"
import style0 from "./ProjectComments.vue?vue&type=style&index=0&id=85d5edcc&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d5edcc",
  null
  
)

export default component.exports